import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { InputsTemplate } from '../../../inputs/InputsTemplate';
import { FormTemplate } from '../../FormTemplate';

import {
  appendCommentFields,
  appendCommentInitialValues,
  mock,
} from '../../../../../lib/mocks/add-owner-comment';

import { selectUserToken } from '../../../../../redux/features/user/userSelectors';
import {
  useAppendRealtyCommentMutation,
  useUpdateRealtyCommentMutation,
} from '../../../../../redux/services/realties/realtiesApi';
import { showSuccess, showError } from '../../../../../utils/ui';
import { successMessages } from '../../../../../data/constants';

// Any agent may edit the shared "i" comment or add a line signed with their name.
export const AddOwnerComment = ({ realty = {}, handleClose = () => {} }) => {
  const token = useSelector(selectUserToken);
  const [updateComment] = useUpdateRealtyCommentMutation();
  const [appendComment] = useAppendRealtyCommentMutation();

  const formInitialValues = useMemo(() => {
    const savedComment = realty?.comment?.comment_comment;

    if (savedComment && savedComment.trim().length > 0) {
      return {
        owner_comment: savedComment,
      };
    }
    const parts = ['COMMENTS:'];

    if (realty?.text_description?.description_text_en) {
      parts.push(`DESCRIPTION: ${realty.text_description.description_text_en}`);
    }

    if (realty?.main?.external_link) {
      parts.push(`LINK: ${realty.main.external_link}`);
    }

    const combinedText = parts.join('\n\n');

    return {
      owner_comment: combinedText,
    };
  }, [realty]);

  const handleSubmit = async values => {
    try {
      await updateComment({
        token,
        id: realty.id,
        comment: values.owner_comment?.trim() || '',
      }).unwrap();

      showSuccess(
        successMessages.commentUpdated || 'Comment updated successfully'
      );
      handleClose();
    } catch (error) {
      showError(error?.data?.message || 'Failed to update comment');
    }
  };

  const handleAppend = async values => {
    try {
      await appendComment({
        token,
        id: realty.id,
        text: values.new_comment.trim(),
      }).unwrap();

      showSuccess(successMessages.commentAdded);
      handleClose();
    } catch (error) {
      showError(error?.data?.message || 'Failed to add comment');
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <FormTemplate
        initialValues={appendCommentInitialValues}
        handleSubmitForm={handleAppend}
        buttonText={'Add comment'}
        bgColor={'bg-purpleColor border-purpleColor'}
      >
        {formProps => (
          <InputsTemplate
            formProps={formProps}
            inputsList={appendCommentFields}
          />
        )}
      </FormTemplate>

      <FormTemplate
        initialValues={formInitialValues}
        handleSubmitForm={handleSubmit}
        buttonText={'Save'}
        bgColor={'bg-purpleColor border-purpleColor'}
      >
        {formProps => (
          <InputsTemplate
            formProps={formProps}
            inputsList={mock}
          />
        )}
      </FormTemplate>
    </div>
  );
};
